import { render } from "./ItemSearch.vue?vue&type=template&id=8bfef494&scoped=true"
import script from "./ItemSearch.vue?vue&type=script&lang=js"
export * from "./ItemSearch.vue?vue&type=script&lang=js"

import "./ItemSearch.vue?vue&type=style&index=0&id=8bfef494&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bfef494"]])

export default __exports__